<template>
  <div class="concour">
    <div class="inner">
      <SearchCommon type="concour"/>
      <div class="result" :class="resultHide(Concour.results)">
        <h3>コンクール結果一覧</h3>
        <p>過去のコンクール結果を紹介します。</p>
        <div class="result-card-area" v-if="Concour">
        <card_s v-for="(result, i) in Concour.results" :data="result" :i="i" :key="Concour.results.ID + '_' + i" />
        </div>
      </div>
      <div class="organizer-links">
        <h4>主催社企業リンク</h4>
        <ul>
          <li v-for="bnr in Concour.banner" v-if="Concour.banner" :key="bnr.ID">
            <a class="alp" :href="bnr.link" target="_blank"><img :src="bnr.img" :alt="bnr.title"></a>
          </li>
        </ul>
      </div>
      <p class="pagetop"><a class="alp" href="#">ページトップへ</a></p>
    </div>
    <div class="bottom-nav">
      <ul>
        <li class="teaching alp"><a href="/teaching/"><span>教材</span></a></li>
        <li class="event alp"><a href="/event/"><span>イベント</span></a></li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>

@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;

$white-border: 0 2px 1px #fff, 2px 0 1px #fff, 0 -2px 1px #fff, -2px 0 1px #fff,
  -2px -2px 1px #fff, 2px -2px 1px #fff, -2px 2px 1px #fff, 2px 2px 1px #fff;

.concour {
  .inner {
    max-width: 1000px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10px;
  }

  .result {
    &.none {
      display: none;
    }
    margin: 60px 0 0;
    h3 {
      font-size: 26px;
      font-weight: bold;
      color: #fff;
      background: url(../assets/img/common/result_ttl_bg_pc.png) no-repeat top
        center;
      text-align: center;
      line-height: 59px;
    }
    h3 + p {
      font-size: 14px;
      font-weight: bold;
      margin: 22px 0 30px;
      text-align: center;
      text-shadow: $white-border;
    }
    .result-card-area {
      @include flex(start);
      flex-wrap: wrap;
    }
  }
  .organizer-links {
    margin-top: 60px;
    padding: 35px 25px 50px;
    background: #fff;
    h4 {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    ul {
      @include flex(start);
      flex-wrap: wrap;
      li {
        margin: 10px 4% 0 0;
        width: 13.3%;
        img {
          width: 100%;
        }
        &:nth-of-type(6n) {
          margin-right: 0;
        }
      }
      li:nth-of-type(1) {
        width: 13.3%;
        margin-right: 4.3%;
      }
      li:nth-of-type(2) {
        width: 11%;
        margin-right: 4.3%;
      }
      li:nth-of-type(3) {
        width: 8.6%;
        margin-right: 4.3%;
      }
      li:nth-of-type(4) {
        width: 13.6%;
        margin-right: 4.3%;
      }
      li:nth-of-type(5) {
        width: 13.8%;
        margin-right: 4.3%;
      }
      li:nth-of-type(6) {
        width: 17.8%;
      }
    }
  }
  .bottom-nav ul {
    width: 300px;
  }

  @media only screen and (max-width: 750px) {
    $white-border2: 0 1px 1px #fff, 1px 0 1px #fff, 0 -1px 1px #fff, -1px 0 1px #fff,
  -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff, 1px 1px 1px #fff;
    .inner {
      padding: 0;
    }

    .result {
      margin: 13.5vw 0 0;
      h3 {
        padding: 2vw 0;
        font-size: 1.8rem;
        line-height: 1;
        font-weight: 500;
        background: url(../assets/img/common/result_ttl_bg_sp.png) no-repeat top
          center;
        background-size: 100% auto;
      }
      h3 + p {
        margin: 3vw 0 4vw;
        font-size: 0.8rem;
      }

      .result-card-area {
        @include flex(space-between);
        .card_s:nth-of-type(1),
        .card_s:nth-of-type(2) {
          margin-top: 0;
        }
      }
    }
    .organizer-links {
      margin-top: 14vw;
      padding: 7vw 6vw 7.5vw;
      h4 {
        font-size: 1.2rem;
        letter-spacing: 0.1em;
        margin-bottom: 2vw;
      }
      ul {
        li {
          margin: 5vw 8% 0 0;
          width: 28%;
          a {
            display: block;
          }
          &:nth-of-type(3n) {
            margin-right: 0 !important;
          }
        }
        li:nth-of-type(1) {
          width: 30%;
          margin-right: 11%;
        }
        li:nth-of-type(2) {
          width: 25%;
          
          margin-right: 11%;
        }
        li:nth-of-type(3) {
          width: 22%;
        }
        li:nth-of-type(4) {
          width: 26%;
          margin-right: 6%;
        }
        li:nth-of-type(5) {
          width: 27%;
          margin-right: 6%;
        }
        li:nth-of-type(6) {
          width: 35%;
        }
      }
    }
  }
}
</style>

<script>
import Base from "./_Base";
import card from "../components/card";
import card_s from "../components/card_s";

export default {
  mixins: [Base],
  data: function() {
    return {
      resultHideClass: "none"
    };
  },
  components: {
    card,
    card_s
  },
  computed: {
    Concour (){
      return this.$store.state.data.Concour || {};
    }
  },
  methods: {
    resultHide: function(data) {
      if(data == 0){
        console.log(data);
        return this.resultHideClass;
      }
    }
  }
};
</script>
